
export default class Burger {
    
    static get selector() {
        return '.gotomenu';
    }

    constructor(el) {
        this.burger = el;


        this.setEvents();
    }

    open() {
        if(this.isOpen) return;
        //window.scrollTo(0,0);
        document.body.classList.add('menuOpen');
        this.isOpen = true;
    }

    close() {
        if(!this.isOpen) return;
        document.body.classList.remove('menuOpen');
        this.isOpen = false;
    }



    setEvents() {
        window.addEventListener('resize', this.e_resize.bind(this));
        this.burger.addEventListener('click', this.e_clickBurger.bind(this));
    }

    e_clickBurger(e) {
        e.preventDefault();
        e.target.blur();
        if(!this.isOpen) this.open();
        else this.close();
    }

    e_resize(e) {
        this.close();
    }


}